class TextMessageRequest {
    constructor(public message?: string) { }
}

export default TextMessageRequest;
